import { Component, h, Host, Prop } from '@stencil/core';

import { MessagesStore } from '../../../../../utils/Stores/messages-store';

@Component({
  tag: 'bot-messages-component',
  styleUrl: 'bot-messages-module.scss',
  shadow: true,
})
export class ModuleBotMessages {
  @Prop() readonly messages: IWCChatMessage[];

  render() {
    return (
      <Host>
        {this.messages?.map((message, index) => {
          return (
            <bot-message-component
              class={{ 'chat-messages__all': true }}
              lastMessage={{ total: MessagesStore?.get('messages')?.length - 1, index }}
              message={message}
            ></bot-message-component>
          );
        })}
      </Host>
    );
  }
}
